import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CorrigirJogos.css'; // Importando o CSS

const CorrigirJogos = () => {  
  const [concursos, setConcursos] = useState([]);
  const [selectedConcurso, setSelectedConcurso] = useState('');
  const [resultados, setResultados] = useState([]);
  const [numerosSorteados, setNumerosSorteados] = useState([]);
  const [totalPremios, setTotalPremios] = useState({ 11: 0, 12: 0, 13: 0, 14: 0, 15: 0 });
  const [jogos, setJogos] = useState([]);
  const [arquivoCarregado, setArquivoCarregado] = useState(false);

  useEffect(() => {
    fetch('/Concursos.json')
      .then(response => response.json())
      .then(data => {
        const concursosOrdenados = data.dataroot.ConcursoWebApp.sort((a, b) => b.Concurso - a.Concurso);
        setConcursos(concursosOrdenados);
      })
      .catch(error => console.error('Error fetching Concursos.json:', error));
  }, []);

  const handleConcursoSelect = (event) => {
    const concursoSelecionado = concursos.find(c => c.Concurso === event.target.value);
    if (concursoSelecionado) {
      setSelectedConcurso(event.target.value);
      const numeros = [
        concursoSelecionado.Bola1, concursoSelecionado.Bola2, concursoSelecionado.Bola3,
        concursoSelecionado.Bola4, concursoSelecionado.Bola5, concursoSelecionado.Bola6,
        concursoSelecionado.Bola7, concursoSelecionado.Bola8, concursoSelecionado.Bola9,
        concursoSelecionado.Bola10, concursoSelecionado.Bola11, concursoSelecionado.Bola12,
        concursoSelecionado.Bola13, concursoSelecionado.Bola14, concursoSelecionado.Bola15
      ];
      setNumerosSorteados(numeros);
      processarJogos(jogos, numeros);
    }
  };

  const processarJogos = (jogos, numerosSorteados) => {
    const resultadosProcessados = jogos.map((jogo, index) => {
      const pontos = jogo.filter(numero => 
        numerosSorteados.includes(numero.toString())
      ).length;
      return {
        id: index + 1,
        dezenas: jogo,
        pontos: pontos
      };
    });

    const totais = { 11: 0, 12: 0, 13: 0, 14: 0, 15: 0 };
    resultadosProcessados.forEach(resultado => {
      if (resultado.pontos >= 11) {
        totais[resultado.pontos]++;
      }
    });

    setResultados(resultadosProcessados);
    setTotalPremios(totais);
  };

  const getPontosColor = (pontos) => {
    const colors = {
      11: 'blue',
      12: 'green', 
      13: 'orange',
      14: 'red',
      15: 'purple'
    };
    return colors[pontos] || 'black';
  };

  const calcularPremio = (pontos, quantidade) => {
    const valores = {
      11: 6,
      12: 12,
      13: 30,
      14: 2000,
      15: 1700000
    };
    return (valores[pontos] * quantidade).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      alert('Por favor, selecione um arquivo antes de tentar abrir.');
      return;
    }
  
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      const decodedText = atob(text);
      const jogosArray = decodedText.split('\n').map(jogo => jogo.split(', ').map(Number));
      setJogos(jogosArray);
      setArquivoCarregado(true);
    };
    reader.readAsText(file);
  };
  

  return (
    <div className="container-fluid" style={{ height: '100vh', overflowY: 'auto' }}>
      <div className="row mb-4">
        <div className="col">
          <h2>Corrigir Jogos</h2>
          <input type="file" className="form-control" accept=".ltc" onChange={handleFileChange} />
          <button className="btn btn-primary mt-2" onClick={handleFileChange}>Abrir Jogos</button>
        </div>
      </div>

      {arquivoCarregado && (
        <div className="row mb-4">
          <div className="col">
            <h2>Selecionar Concurso</h2>
            <select className="form-control" onChange={handleConcursoSelect} value={selectedConcurso}>
              <option value="">Selecione um Concurso</option>
              {concursos.map(concurso => (
                <option key={concurso.Concurso} value={concurso.Concurso}>
                  Concurso {concurso.Concurso}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      {selectedConcurso && (
        <>
          <div className="row mb-4">
            <div className="col">
              <h2>Dezenas Sorteadas</h2>
              <div className="d-flex flex-wrap gap-2">
                {Array.from({ length: 25 }, (_, i) => i + 1).map(num => (
                  <button
                    key={num}
                    className={`btn ${numerosSorteados.includes(num.toString()) ? 'btn-success' : 'btn-secondary'}`}
                    disabled
                  >
                    {num}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col">
              <h2>Total de Prêmios</h2>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Pontos</th>
                      <th>Quantidade</th>
                      <th>Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[15, 14, 13, 12, 11].map(pontos => (
                      <tr key={pontos}>
                        <td>{pontos}</td>
                        <td>{totalPremios[pontos]}</td>
                        <td>{calcularPremio(pontos, totalPremios[pontos])}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}

      {resultados.length > 0 && (
        <div className="row mb-4 justify-content-center">
          <div className="col-12">
            <h2 className="text-center">Jogos Premiados</h2>
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Jogo Nº</th>
                    <th>Dezenas</th>
                    <th>Pontos</th>
                  </tr>
                </thead>
                <tbody>
                  {resultados.map((resultado) => (
                    <tr key={resultado.id}>
                      <td>{resultado.id}</td>
                      <td>{resultado.dezenas.join(', ')}</td>
                      <td style={{ color: getPontosColor(resultado.pontos), fontWeight: resultado.pontos >= 11 ? 'bold' : 'normal' }}>
                        {resultado.pontos >= 11 ? resultado.pontos : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CorrigirJogos;
